import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';

// allow: 'merchant' → only merchants; 'staff' → only non-merchants (staff/admin).
function RoleRoute({ allow, children }) {
  const { isMerchant } = useAuth();
  const permitted = allow === 'merchant' ? isMerchant : !isMerchant;
  return permitted ? children : <Navigate to='/' replace />;
}

export default RoleRoute;
